export default "__VITE_ASSET__Cmy$eoCm__"